module.exports = __webpack_public_path__ + "img/record.7b77d84b.svg";